import { Box, Button } from "@mui/material";
import { Typography } from "@mui/material";


const FilterComponent = ({
  onFilterChange,
}: {
  onFilterChange: (value: string) => void;
}) => {
  const filterOptions = [
    { value: "thisMonth", label: "This Month" },
    { value: "this3Months", label: "3 Months" },
    { value: "this6Months", label: "6 Months" },
    { value: "thisYear", label: "1 Year" },
    { value: "selectPeriod", label: "Select Period" },
  ];

  return (
    <Box gap={2}
      sx={{
        width: "300px",
      
        backgroundColor: "white",
        
        padding: "1rem",
    background: `linear-gradient( #2C2F33, #2C2F33) padding-box, 
                linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box;`,
    border: "1.4px solid transparent",
    borderTopLeftRadius: "26px",
    borderBottomLeftRadius: "26px",
    borderBottomRightRadius: "26px",
    

    
      }}
    >
      <Box mb={2}><Typography variant="h6" sx={{color:"white"}}>Select Filter</Typography></Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)", // 3 buttons per row
          gap: 2,
        }}
      >
        {filterOptions.slice(0, 3).map((option) => (
          <Button sx={{background: `linear-gradient(rgb(23, 24, 30), rgb(29, 31, 41)) padding-box, 
            linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box;`,
border: "1.4px solid transparent",
borderRadius:"20px", color:"white",fontSize:"10px",fontFamily:"Opensans",textTransform:"none",fontWeight:"400"}}
            key={option.value}
            // variant="contained"
            onClick={() => onFilterChange(option.value)}
          >
            {option.label}
          </Button>
        ))}
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)", // 2 buttons per row
          gap: 2,
          marginTop: "10px",
        }}
      >
        {filterOptions.slice(3).map((option) => (
          <Button sx={{background: `linear-gradient(rgb(23, 24, 30), rgb(29, 31, 41)) padding-box, 
            linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box;`,
border: "1.4px solid transparent",
borderRadius:"20px", color:"white",fontSize:"10px",fontFamily:"Opensans",textTransform:"none",fontWeight:"400"}}
            key={option.value}
            // variant="contained"
            onClick={() => onFilterChange(option.value)}
          >
            {option.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default FilterComponent;
